import Vue from 'vue';
import Vuex from 'vuex';
import ui from './modules/ui';
import landing from './modules/landing';
import auth from './modules/auth';
import filters from './modules/filters';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;

const store = new Vuex.Store({
  state: {
    error: null
  },
  actions: {
    RESET_ERROR_PROPERTY({ commit }) {
      commit('RESET_ERROR_PROPERTY');
    }
  },
  mutations: {
    RESET_ERROR_PROPERTY(state) {
      state.error = null;
    },
    ERROR_OCCURRED(state, error) {
      state.error = error;
    }
  },
  modules: {
    ui,
    landing,
    auth,
    filters
  },
  strict: debug
});

export { store as default };
